import { connect } from 'react-redux'
import { StoreDispatch } from 'interfaces/component'
import { State } from 'interfaces/state'
import { InsightCTAKey, InsightCTAFullContainer, CtaInsightOptions, Insight } from 'interfaces/insights'

import InsightFooter, { InsightFooterStateProps, InsightFooterDispatchProps, InsightFooterOwnProps } from 'components/features/insights/InsightFooter/InsightFooter'
import { toggleDismissInsightActionCreator, seeNextInsightActionCreator, insightCtaClickActionCreator } from 'actions/insightsActions'
import { currentPageSelector } from 'selectors/globalSelectors'
import { isTimeframedPage, isCategorizedPage } from 'helpers/pageHelpers'
import { withRouter, RouteComponentProps } from 'react-router-dom'
import { toggleNotificationsExpandedActionCreator } from 'actions/notificationsActions'

type InsightFooterContainerInnerProps = InsightFooterOwnProps & RouteComponentProps<{}>

const mapStateToProps = (state: State, ownProps: InsightFooterContainerInnerProps): InsightFooterStateProps => {
  const page = currentPageSelector(state, ownProps)

  const timeframe = isTimeframedPage(page)
    ? state.app[page].timeframe
    : null

  const categoryId = isCategorizedPage(page)
    ? state.app[page].categories.selectedId
    : null

  return {
    page,
    timeframe,
    categoryId,
  }
}

const mapDispatchToProps = (dispatch: StoreDispatch, ownProps: InsightFooterOwnProps): InsightFooterDispatchProps => ({
  dismiss: () => dispatch(toggleDismissInsightActionCreator(ownProps.insight, true)),
  undismiss: () => dispatch(toggleDismissInsightActionCreator(ownProps.insight, false)),
  seeNext: () => dispatch(seeNextInsightActionCreator(ownProps.insight)),

  performCta: <T extends InsightCTAKey>(type: T, cta: InsightCTAFullContainer[T] | undefined, insight: Insight, options?: CtaInsightOptions) => {
    if (!cta) {
      return
    }
    dispatch(insightCtaClickActionCreator(type, cta, insight, options))
  },
  closeNotifications: () => dispatch(toggleNotificationsExpandedActionCreator(false)),
})

const InsightFooterContainerInner = connect<InsightFooterStateProps, InsightFooterDispatchProps, InsightFooterContainerInnerProps>(
  mapStateToProps, mapDispatchToProps
)(InsightFooter)
const InsightFooterContainer = withRouter(InsightFooterContainerInner)

export default InsightFooterContainer
